
<template>

	<setup_content class="main-container" title="Корректировки">
		<b-overlay class="main-container" :show="wait">
			<elements
				ref="table"
				style="flex: 1;"
				service="cadastral_corrections"
				without_back_button
				:without_add="! check_roles([ 'model' ]) || not_editable"
				:not_able_for_delete="! check_roles([ 'model' ])"
				without_context_menu 
				:many_edit="check_roles([ 'model' ]) && ! not_editable"
				:attrs="attrs"
				initial_sort_by="order"
				:initial_sort_desc="false"
				:with_show_attrs="false"
				:additional_query="{ cost_evaluation : id }"
				essence_name_genetive_case="корректировки"
				essence_name_for_plural_1="корректировку"
				essence_name_for_plural_234="корректировки"
				essence_name_for_plural_others="корректировок"
			>
		
				<template v-slot:modal_dialogs>
		
					<addCorrection ref="add_element" :id="id" v-on:need_refresh="refresh"/>
		
				</template>
		
				<template v-slot:first_nav_items>
		
					<b-button v-if="check_roles([ 'model' ]) && $refs.table && $refs.table.ids_for_edit.length" v-b-tooltip:fullscreen.hover.bottomright variant="outline-danger" title="Удалить корректировку" v-on:click="delete_many">
		
						<base-icon name="delete" />
		
					</b-button>
		
				</template>
		
			</elements>
		</b-overlay>
	</setup_content>

</template>

<script>

import api from "../../../../../api"
import elements from "../../../../elements"
import addCorrection from "./add.vue"
import setup_content from "../setup_assets/content"

export default
{
	props :
	{
		id : String,
		group_id : String,
		not_editable : Boolean,
	},

	components :
	{
		elements,
		addCorrection,
		setup_content,
	},

	data()
	{
		return {

			wait : false,
			attrs :
			[
				{
					key : "name",
					label : "Наименование",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					type : "str"
				},
				{
					key : "type",
					label : "Тип корректировки",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					type : "str",
					reference :
					{
						service : "cadastral",
						name : "correction_types",
					},
				},
				{
					key : "order",
					label : "Порядок применения",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					type : "number",
				},
				{
					key : "value",
					label : "Значение корректировки",
					sortable : true,
					visible : true,
					visible_if_no_visible : true,
					in_query : true,
					type : "number",
				},
				{
					key : "apply",
					label : "Корректировка применена",
					sortable : true,
					visible : true,
					in_query : true,
					type : "bool",
				},
			],

		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		delete_many()
		{
			var promises = []

			this.wait = true
			var clean_calculation = false

			this.$refs.table.ids_for_edit.forEach(
				id =>
				{
					if(this.$refs.table.elements.find(elem => elem.id == id).apply)
						clean_calculation = true

					promises.push(api.call(this, "cadastral_corrections", "delete", { id : id }, () => {}))
				})

			Promise.all(promises).then(
				() =>
				{
					if(clean_calculation)
						return api.call(this, "cadastral_groups", "clean_evaluation_for_comparative", { id : this.group_id }, () => {})
				})
				.then(
				() =>
				{
					this.$refs.table.refresh()
					this.$emit("need_refresh")

					this.wait = false
					this.$refs.table.ids_for_edit = []
				})
		},

		refresh()
		{
			this.$refs.table.refresh()

			this.$emit("need_refresh")
		},
	}
}

</script>

